<template>
  <v-card flat>
    <v-card-title>
      <v-btn icon @click="cancel()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      {{ $lang("reservations.card_details.title") }}
    </v-card-title>
    <v-card-text  min-height="500">
      <v-container v-if="!initialized">
        <v-row>
          <v-col cols="12" xs="12" md="12">
            <v-skeleton-loader
              :tile="false"
              :boilerplate="false"
              type="card"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="initialized">
        <v-row>
          <v-col cols="12" xs="12" md="12" v-if="$can('INTERNAL_SUPPORT')" class="admin">
            <v-btn small block @click="getCardSecondaryUser">CHECK SECONDARY USER</v-btn>
            <v-text-field
              v-model="secondaryUser"
              dense
            />
          </v-col>
          <v-col v-if="isPinEnabled" cols="12" xs="12" md="12">
            <div v-if="!!details.cvvWithUI">
              <iframe name="card-details" style="border: none;" width="100%" height="400px" :src="details.cvvWithUI.redirectUrl"></iframe>
            </div>
            <v-btn @click="$emit('addCard')" block color="primary">
              {{ $lang("reservations.card_details.add_replace") }}
            </v-btn>
          </v-col>
          <v-col v-else cols="12" xs="12" md="12">
            <v-alert type="warning">
              <p class="title">{{ $lang("reservations.card_details.no_api_user.title") }}</p>
              <p class="subtitle">{{ $lang("reservations.card_details.no_api_user.text") }}</p>
            </v-alert>
            <v-text-field
              v-model="form.name"
              :label="$lang('reservations.card_details.user_name')"
              :error="!!validation.name"
              :error-messages="!!validation.name ? validation.name : []"
            ></v-text-field>
            <v-text-field
              v-model="form.phone"
              :label="$lang('reservations.card_details.phone')"
              :error="!!validation.phone"
              :error-messages="!!validation.phone ? validation.phone : []"
              hint="Formato 0039xxxxxxx"
            ></v-text-field>
            <v-text-field
              v-model="form.email"
              :label="$lang('reservations.card_details.email')"
              :error="!!validation.email"
              :error-messages="!!validation.email ? validation.email : []"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions v-if="!isPinEnabled">
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit()" :loading="loading" :disabled="loading">{{ $lang("reservations.card_details.request_pin") }}</v-btn>
      <v-btn color="error" @click="cancel()">{{ $lang("main.crud.cancel") }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";

  import formable from "@/mixins/formable";

  import {
    GET_CARDS_DETAILS,
    GET_CARD_SECONDARY_USER,
    CREATE_CARDS_API_USER,
    CREATE_CARDS_API_USER_RESET,
  } from "@/store/cards/actions";

  export default {
    name: "CardDetails",
    mixins: [
      formable
    ],
    props: [
      'data',
    ],
    data() {
      return {
        form: {
          name: null,
          phone: null,
          email: null,
        }
      }
    },
    beforeMount() {
      this.getCardDetails();

      if (this.data.api.phone) {
        this.form.phone = this.data.api.phone;
      }

      if (this.data.api.email) {
        this.form.email = this.data.api.email;
      }
    },
    methods: {
      getCardDetails() {
        if (
          this.data.api.user &&
          this.data.ccs_token
        ) {
          this.$store.dispatch(GET_CARDS_DETAILS, {
            api_user: this.data.api.user,
            ccs_token: this.data.ccs_token,
          }).catch(error => {
            const errorMessage = error.message ? error.message : $lang('main.exceptions.general')
            this.showNotification(errorMessage, 'error');
          });
        }
      },
      resetAction() {
        return CREATE_CARDS_API_USER_RESET;
      },
      submitAction() {
        return CREATE_CARDS_API_USER;
      },
      submitActionOptions() {
        return { ...this.data.api, ...this.form };
      },
      getCardSecondaryUser() {
        this.$store.dispatch(GET_CARD_SECONDARY_USER, {
          ccs_token: this.data.ccs_token
        })
      }
    },
    computed: {
      initialized() {
        return !this.detailsRequest.loading;
      },
      isPinEnabled() {
        return this.data.api.user;
      },
      ...mapState({
        details: state => state.cards.getCardDetailsRequest.data,
        detailsRequest: state => state.cards.getCardDetailsRequest,
        loading: state => state.cards.createApiUserRequest.loading,
        validation: state => state.cards.createApiUserRequest.errors,
        secondaryUser: state => state.cards.getCardSecondaryUser.data,
      })
    }
  };
</script>

<style scoped>
</style>
